export const ROUTE_COACH_HOME = 'coach.home';

export const ROUTE_COURSE_HOME = 'course.home';
export const ROUTE_COURSE_VIEW = 'course.view';
export const ROUTE_COURSE_CREATE = 'course.create';
export const ROUTE_COURSE_CREATE_DATE_SELECTOR = 'course.create.date-selector';
export const ROUTE_COURSE_CREATE_TIME_SELECTOR = 'course.created.time-selector';
export const ROUTE_COURSE_CREATE_CONTENT = 'course.create_content';
export const ROUTE_COURSE_CREATE_CREATED = 'course.create.created';

export const ROUTE_GUIDE = 'guide';

export const ROUTE_SHARE_VIEW = 'share.view';
export const ROUTE_SHARE_COURSE = 'share.course';
export const ROUTE_SHARE_UNBOUND = 'share.unbound';
export const ROUTE_SHARE_TIMES = 'share.times';
export const ROUTE_SHARE_START = 'share.start';
export const ROUTE_SHARE_BINDING = 'share.binding';
export const ROUTE_SHARE_REQUEST = 'share.request';
export const ROUTE_SHARE_QRCODE = 'share.qrcode';

export const ROUTE_TRAINER_HOME = 'trainer.home';

export const ROUTE_TRAINER_APPLY_SEARCH = 'trainer_apply.search';
export const ROUTE_TRAINER_APPLY_COACH_MISSING = 'trainer_apply.coach_missing';
export const ROUTE_TRAINER_APPLY_COACH_SEPARATED = 'trainer_apply.coach_separated';
export const ROUTE_TRAINER_APPLY_QRCODE = 'trainer_apply.qrcode';

export const ROUTE_WECHAT_CALLBACK = 'wechat.callback';



// WEBPACK FOOTER //
// ./src/router/names.js